module.exports = {"vesselName":"","vessel":"","items":[],"user":"","validateErrors":[],"successMessage":{},"loadingPortName":""}


//////////////////
// WEBPACK FOOTER
// ./app/mocks/vessel/size.json
// module id = 689
// module chunks = 0